import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { cornType, getCornKernels, makeCorn } from '@eigtech/shared-corn';
import { z } from 'zod';
// #region Service
export const serviceName = 'inspections';
export const inspectionsServiceCorn = (resourceType) => cornType(serviceName, resourceType);
export const InspectionsServiceCornSchema = cornType(serviceName);
// #endregion Service
// #region Inspection
export const InspectionEntityCornSchema = z.union([ClaimV2CornSchema, JobCornSchema]);
export const InspectionCornSchema = inspectionsServiceCorn('inspection');
export const isInspectionCorn = (corn) => InspectionCornSchema.safeParse(corn).success;
// #endregion Inspection
// #region Media
export const InspectionMediaTypeSchema = z.enum(['video', 'image', 'document']);
export const InspectionMediaTypeEnum = InspectionMediaTypeSchema.enum;
export const mediaTypeByCorn = (corn) => {
    try {
        return InspectionMediaTypeSchema.parse(getCornKernels(corn).resourceType);
    }
    catch {
        return undefined;
    }
};
export const VideoCornSchema = inspectionsServiceCorn(InspectionMediaTypeEnum.video);
export const isVideoCorn = (corn) => VideoCornSchema.safeParse(corn).success;
export const ImageCornSchema = inspectionsServiceCorn(InspectionMediaTypeEnum.image);
export const isImageCorn = (corn) => ImageCornSchema.safeParse(corn).success;
export const makeVideoCorn = (resourceId) => makeCorn({ serviceName, resourceType: InspectionMediaTypeEnum.video, resourceId });
export const makeImageCorn = (resourceId) => makeCorn({ serviceName, resourceType: InspectionMediaTypeEnum.image, resourceId });
export const DocumentCornSchema = inspectionsServiceCorn(InspectionMediaTypeEnum.document);
export const isDocumentCorn = (corn) => DocumentCornSchema.safeParse(corn).success;
export const makeDocumentCorn = (resourceId) => makeCorn({ serviceName, resourceType: InspectionMediaTypeEnum.document, resourceId });
// #endregion Media
// #region Note
export const NoteCornSchema = inspectionsServiceCorn('note');
export const isNoteCorn = (corn) => NoteCornSchema.safeParse(corn).success;
export const makeNoteCorn = (resourceId) => makeCorn({ serviceName, resourceType: 'note', resourceId });
// #endregion Note
// #region SSM Parameters
export const InspectionsParameterSchema = z.enum(['INSPECTIONS_BASE_URL']);
export const InspectionsParameterEnum = InspectionsParameterSchema.enum;
// #endregion SSM Parameters
